module.exports = __webpack_public_path__ + "static/media/uob.216b1522.jpg";